export default __webpack_public_path__ + "static/media/success.0019c025.svg";